
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"83","height":"80","viewBox":"0 0 83 80","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M82.737 27.223a6.593 6.593 0 0 0-6.392-8.284h-8.754c-.017-.003-.033-.008-.05-.012a2.052 2.052 0 0 0-.85.012H30.925a2.063 2.063 0 0 0-.668 0H18.362L15.6 5.517A6.842 6.842 0 0 0 8.902 0H2.036a2.036 2.036 0 0 0 0 4.07h6.866c.633.012 1.245.241 1.73.65.485.406.816.968.937 1.59l2.897 14.054c.04.208.113.403.21.58-.003.14.008.278.035.417l6.322 32.179h-.766a7.125 7.125 0 0 0-6.17 10.686 7.123 7.123 0 0 0 6.17 3.562h.91a8.143 8.143 0 0 0-1.093 4.07c0 2.16.858 4.23 2.384 5.758a8.146 8.146 0 0 0 11.514 0 8.138 8.138 0 0 0 1.292-9.828h22.541a8.143 8.143 0 0 0-1.093 4.07c0 2.16.858 4.23 2.384 5.758a8.146 8.146 0 0 0 11.514 0 8.14 8.14 0 0 0-5.757-13.899H20.268a3.053 3.053 0 1 1 0-6.105H73.19a2.036 2.036 0 0 0 1.953-1.528l6.397-24.316c.021-.068.04-.138.054-.21l1.141-4.336.003.001zM31.106 68.982a4.065 4.065 0 0 1 0 5.757 4.07 4.07 0 1 1 0-5.757zm37.83 2.878a4.07 4.07 0 1 1-8.141 0 4.07 4.07 0 0 1 8.141 0zm9.416-47.866c.48.621.648 1.43.454 2.19l-.77 2.93H67.611l1.235-6.106h7.497c.786 0 1.527.365 2.009.985v.001zm-3.524 17.334H65.14l1.647-8.142h10.18l-2.138 8.142h-.001zM50.616 53.54v-8.142h9.529l-1.628 8.142h-7.9zm-11.378 0-1.634-8.142h8.941v8.142h-7.307zm-14.005 0-1.606-8.142h9.72l1.623 8.142h-9.737zm21.312-24.426h-12.21l-1.225-6.106h13.435v6.106zm4.071-6.106H64.62l-1.22 6.106H50.615v-6.106zm-4.07 10.177v8.141h-9.758l-1.634-8.141h11.391zm-14.012 8.141h-9.71l-1.607-8.141h9.693l1.624 8.141zm18.082 0v-8.141h11.97l-1.628 8.141H50.615h.001zM28.88 23.008l1.218 6.106h-9.684l-1.205-6.106h9.671zM71.621 53.54h-8.95l1.646-8.142h9.443l-2.138 8.142h-.001z","fill":"#069","fill-rule":"nonzero"}})])
          )
        }
      }
    